import React, { useEffect, useState } from "react";
import Grid from '@mui/material/Grid2';
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useTranslation } from "react-i18next";
import { useErrorNotification } from "@common/components/Notification";
import {
  MeetingPurpose,
  MeetingSource,
  ScheduledMeeting,
} from "@services/meetings/types";
import { useSimpleReducer } from "@common/hooks";
import RightDrawer from "@common/components/RightDrawer";
import { User } from "@services/user/types";
import { postMonitoringMeeting } from "@services/monitoring";
import { getAssignees } from "@services/meetings";
import { SetupProducerFormType } from "../../SetupProducer";
import { Assignee } from "@services/meetings/assignee";
import Button from "@common/components/Button";
import { Box } from "@mui/material";
import ChangeProducer from "../../SetupProducer/ChangeProducer";

type UpdateProducerProps = {
  open: boolean;
  setOpen: Function;
};

const UpdateProducer = (props: UpdateProducerProps) => {
  const { open, setOpen } = props;
  const { t } = useTranslation();
  const context = React.useContext(RoomsRealtimeContext);
  const [assignees, setAssignees] = useState<Assignee[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [{ producer }, dispatch] = useSimpleReducer<SetupProducerFormType>({
    source: MeetingSource.Symphony,
    owner: "",
    requester: "",
    purpose: MeetingPurpose.RegularMeeting,
    vip: false,
    producer: { id: "" },
  });
  const dispatchError = useErrorNotification();

  useEffect(() => {
    const fetch = async () => {
      try {
        setAssignees(
          await getAssignees([context.detail?.meeting?.account?.id ?? ""])
        );
      } catch (e) {
        dispatchError(e);
      }
    };
    if (context.detail?.meeting) fetch();
  }, [context.detail?.meeting]);

  const onClickUpdate = async () => {
    setLoading(true);
    try {
      await postMonitoringMeeting(context.detail?.meeting?.id ?? 0, {
        ...(context.detail?.meeting as ScheduledMeeting),
        producer: producer.id === "" ? undefined : (producer as User),
      });
      context.detail?.refetch();
      setOpen(false);
    } catch (e) {
      dispatchError(e);
    }
    setLoading(false);
  };

  return (
    <RightDrawer
      title={t("Change Producer")}
      open={open}
      onClose={() => setOpen(false)}
      closeButton={
        <Grid
          sx={(theme) => ({
            "&>.MuiButton-root": { marginRight: theme.spacing(1) },
          })}>
          <Button
            variant="contained"
            color="white"
            onClick={() => onClickUpdate()}
            loading={loading}
          >
            Update
          </Button>
          <Button
            color="greyed"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </Grid>
      }
    >
      <Box sx={{
        padding: "1rem"
      }}>
        <ChangeProducer
          producer={producer}
          dispatch={dispatch}
          assignees={assignees}
        />
      </Box>
    </RightDrawer>
  );
};

export default UpdateProducer;
